import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSitepointComponent } from './simple-icons-sitepoint.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSitepointComponent ],
    exports:      [ SimpleIconsSitepointComponent ],
    bootstrap:    []
})
export class SimpleIconsSitepointModule {}
